import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07beef31"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "img-box" }

import { PropType, ref } from 'vue'
import { ICoordinate } from '@/utils/interface'

interface Style {
  width: string
  height: string
  top: string
  left: string
  position: string
  zIndex: number
  border: string
}


export default /*#__PURE__*/_defineComponent({
  props: {
  detResultList: {
    type: Array as PropType<ICoordinate[]>,
    default() {
      return []
    }
  },
  imageUrl: {
    type: String,
    default() {
      return ''
    }
  }
},
  setup(__props) {

const props = __props



const list = ref<Style[]>([])

list.value = props.detResultList.map((item) => {
  return {
    width: `${((item.xlowright - item.xupleft) / 1280) * 100}%`,
    height: `${((item.ylowright - item.yupleft) / 720) * 100}%`,
    top: `${(item.yupleft / 720) * 100}%`,
    left: `${(item.xupleft / 1280) * 100}%`,
    position: 'absolute',
    zIndex: 1,
    border: '1px solid red'
  }
})

return (_ctx: any,_cache: any) => {
  const _component_van_image = _resolveComponent("van-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_image, {
      width: "100%",
      height: "100%",
      fit: "cover",
      position: "center",
      src: props.imageUrl
    }, null, 8, ["src"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        style: _normalizeStyle((item as any))
      }, null, 4))
    }), 128))
  ]))
}
}

})